import img1 from "../../assets/image/1.webp";
import img2 from "../../assets/image/2.webp";
import img3 from "../../assets/image/3.webp";
import p1 from "../../assets/image/products/01.jpg";
import p2 from "../../assets/image/products/02.jpg";
import p3 from "../../assets/image/products/03.jpg";
import p4 from "../../assets/image/products/04.jpg";
import p5 from "../../assets/image/products/05.jpg";
const Blog = () => {
  return (
    <>
      {/* HERO */}
      <section className="blog-hero">
        <div className="blog-hero-content text-center">
          <h1>NX Blog</h1>

          <div className="blog-search position-relative mt-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search the blog"
            />
            <button>
              <i className="bi bi-search"></i>
            </button>
          </div>
        </div>
      </section>

      {/* CATEGORY NAV */}
      <section className="bg-light">
        <div className="container">
          <ul className="nav blog-nav mb-4">
            <li className="nav-item"><button className="nav-link active">HPC</button></li>
            <li className="nav-item"><button className="nav-link">Data Center</button></li>
            <li className="nav-item"><button className="nav-link">Enterprise Network</button></li>
            <li className="nav-item"><button className="nav-link">Cabling</button></li>
            <li className="nav-item"><button className="nav-link">Newsroom</button></li>
          </ul>
        </div>
      </section>

      {/* CONTENT */}
      <section className="container my-5">
        {/* FEATURED POSTS */}
        <h4 className="mb-4 fw-semibold">Featured Posts</h4>

        <div className="row g-4">
          {[
            { img: p1, title: "PicOS-V Explained for Open Networking" },
            { img: p2, title: "ZAMPCON: Smart Network Automation" },
            { img: p3, title: "Open Ethernet for AI Clusters" },
            { img: p4, title: "NX & Siemens Partnership" },
            { img: p5, title: "NX & Siemens Partnership" }
          ].map((item, i) => (
            <div key={i} className="col-lg col-md-4 col-sm-6">
              <div className="featured-card">
                <img src={item.img} className="w-100" alt={item.title} />
                <div className="p-3">
                  <h6 className="fw-semibold">{item.title}</h6>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* MORE POSTS */}
        <h4 className="mb-4 pt-5 fw-semibold">More Posts</h4>

        <div className="row g-4">
          <div className="col-md-4">
            <div className="nx-card">
              <div className="nx-img-box1">
                <img src={img1} alt="PicOS Switch Software" />
              </div>
              <div className="nx-txt-box">
                <h6>PicOS Switch Software</h6>
                <p>
                  Disaggregated NOS built on industry-standard Debian Linux
                  seamlessly integrates into any network environment.
                </p>
                <div className="nx-blog-meta">
                  <span className="nx-tag">Software</span>
                  <span className="nx-tag">Enterprise Network</span>
                  <span className="nx-tag">Blog</span>
                  <span className="nx-date">Sep 30, 2025</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="nx-card">
              <div className="nx-img-box1">
                <img src={img2} alt="AmpCon Platform" />
              </div>
              <div className="nx-txt-box">
                <h6>AmpCon Management Platform</h6>
                <p>
                  Deploy, orchestrate, and manage data center and campus
                  networks at scale.
                </p>
                <div className="nx-blog-meta">
                  <span className="nx-tag">Software</span>
                  <span className="nx-tag">Enterprise Network</span>
                  <span className="nx-tag">Blog</span>
                  <span className="nx-date">Sep 30, 2025</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="nx-card">
              <div className="nx-img-box1">
                <img src={img3} alt="PicOS-V" />
              </div>
              <div className="nx-txt-box">
                <h6>PicOS-V Virtual Operating System</h6>
                <p>
                  Prototype network ops, validate configuration, and test
                  features with PicOS-V.
                </p>
                <div className="nx-blog-meta">
                  <span className="nx-tag">Software</span>
                  <span className="nx-tag">Enterprise Network</span>
                  <span className="nx-tag">Blog</span>
                  <span className="nx-date">Sep 30, 2025</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
